import { checkLicensePermission } from '../../utility/communityLicense'
import PageHeader from '../common/PageHeader/PageHeader'
import { Outlet, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import './MembersLayout.module.scss'

const MembersLayout = () => {
  const navigate = useNavigate()
  const licenseType = useSelector(state => state.user.current_user.communities[0]?.license_type)


  const FamilyHeaderActionButton = (
    <button
      className='btn btn-primary text-white pull-right mr-2'
      onClick={() => navigate('/students-families/invite-families')}
    >
      Invite Family
    </button>
  )

  return (
    <div id='membersLayout'>
      <PageHeader
        title='Members'
        actionComponent={checkLicensePermission(licenseType, ['standard_legacy']) ? FamilyHeaderActionButton : null}
      />
      <Outlet />
    </div>
  )
}

export default MembersLayout
